import { Box, Skeleton } from '@mui/material'
import { styles } from './style'

export function RangeSkeleton() {
  return (
    <Box sx={styles.rangeItem} aria-label='Range skeleton'>
      <Skeleton width='100%' height={32} />
      <Box sx={styles.inputsRow}>
        <Skeleton width='100%' height={40} />
        <Skeleton width='100%' height={40} />
      </Box>
    </Box>
  )
}
